import React, { useState, useEffect } from 'react'
import { IOffset, IGlasses } from '../store'
import { useStore } from '../hooks'

export interface Dictionary<T> { [Key: string]: T }

export interface IOffsetContext {
    state?: IState,
    editValue?(key: 'RotationX' | 'PositionY' | 'PositionZ', subtract: boolean): void,
    save?(): void,
    selectGlasses?(glasses: IGlasses, glassesId: string): void,
}

interface IState {
    glasses?: IGlasses,
    glassesId?: string,
    localOffset: IOffset,
}

const Offset = React.createContext<IOffsetContext>({})

const defaultLocalOffset = {
    RotationX: 0,
    PositionY: 0,
    PositionZ: 0
}

export function OffsetContext(props) {
    const store = useStore()
    const [state, set] = useState<IState>({
        localOffset: defaultLocalOffset
    })

    // Context value.
    const value: IOffsetContext = {
        state,
        editValue(key, subtract) {
            let k = .001
            if (subtract) k *= -1

            set(p => ({ ...p, localOffset: { ...p.localOffset, [key]: p.localOffset[key] += k } }))
        },
        save() {
            if (state.glasses && state.glassesId) {
                state.glasses.id = state.glassesId
                if (state.glasses.WebOffset) {
                    state.glasses.WebOffset.RotationX += state.localOffset.RotationX
                    state.glasses.WebOffset.PositionY += state.localOffset.PositionY
                    state.glasses.WebOffset.PositionZ += state.localOffset.PositionZ
                } else state.glasses.WebOffset = state.localOffset

                store.dispatch({ type: 'set-glasses', payload: state.glasses })
            }

            set(p => ({ ...p, localOffset: defaultLocalOffset }))
        },
        selectGlasses(glasses, glassesId) {
            set(p => ({
                ...p,
                // localOffset: defaultLocalOffset,
                glasses,
                glassesId
            }))
        }
    }

    return <Offset.Provider value={value}>{props.children}</Offset.Provider>
}

export default Offset
